import { COMPANY_NAME } from '../constants/brand';

export const pageTitle = title => {
  return (document.title = `${title} - ${COMPANY_NAME}`);
};
